export const CURRENCIES = ['USD','EUR','TRY'] as const;
